import Input from "../engine/input";

class StoryDialog {
  constructor() {
    this.overlay = document.querySelector(".overlay");
    this.container = document.querySelector(".story");
  }

  handleInput(input) {
    switch (input) {
      case Input.MoveUp:
        if (this.shouldDisengageFocus()) {
          this.container.scrollBy(0, -32);
        } else {
          this.focusPrevChoice();
        }
        break;
      case Input.MoveDown:
        if (this.hasFullyScrolled()) {
          this.focusNextChoice();
        } else {
          this.container.scrollBy(0, 32);
        }
        break;
      case Input.MoveLeft:
      case Input.FocusLeft:
        this.focusPrevChoice();
        break;
      case Input.MoveRight:
      case Input.FocusRight:
      case Input.FocusNext:
        this.focusNextChoice();
        break;
      case Input.Ok:
        this.clickFocusedElement();
        break;
    }
    return false;
  }

  handleClick() {
  }

  handleRightClick() {
  }

  hasFullyScrolled() {
    return this.container.scrollTop + this.container.offsetHeight >= this.container.scrollHeight;
  }

  rescale() {
    return;
  }

  activate(context) {
    this.showStory(context.character);
    this.overlay.classList.add("is-visible");
    this.container.classList.add("is-visible");
  }

  deactivate(context) {
    this.overlay.classList.remove("is-visible");
    this.container.classList.remove("is-visible");
    this.container.replaceChildren();
  }

  showStory(character) {
    this.character = character;
    this.continueStory();
  }

  leaveStory() {
    this.doneButton = false;
    // This might be a hacky way of communicating with the
    // ui controller as it just calls back into here anyway.
    document.dispatchEvent(new CustomEvent("ui.transition", {
      detail: {
        command: "HideStory",
      }
    }));
  }

  clickFocusedElement() {
    if (this.hasAvailableChoices()) {
      this.choices[this.choiceIndex].click();
    } else if (this.doneButton) {
      this.doneButton.click();
    }
  }

  hasScrollableContent() {
    return (this.container.offsetHeight < this.container.scrollHeight)
  }

  shouldDisengageFocus() {
    if (this.hasAvailableChoices()) {
      return this.choiceIndex == 0 && this.hasScrollableContent();
    }
    return this.hasScrollableContent();
  }

  focusNextChoice() {
    if (!this.hasAvailableChoices()) {
      this.doneButton.focus();
      this.doneButton.classList.add("is-focused");
      return;
    }

    this.choiceIndex = (this.choiceIndex + 1) % this.choices.length;
    
    let i = 0;
    for (const choice of this.choices) {
      if (i == this.choiceIndex) {
        choice.focus();
        choice.classList.add("is-focused");
      } else {
        choice.classList.remove("is-focused");
      }
      i++;
    }
  }

  focusPrevChoice() {
    if (!this.hasAvailableChoices()) {
      this.doneButton.focus();
      this.doneButton.classList.add("is-focused");
      return;
    }

    this.choiceIndex = ((this.choiceIndex - 1) + this.choices.length) % this.choices.length;
    
    let i = 0;
    for (const choice of this.choices) {
      if (i == this.choiceIndex) {
        choice.focus();
        choice.classList.add("is-focused");
      } else {
        choice.classList.remove("is-focused");
      }
      i++;``
    }
  }

  hasAvailableChoices() {
    if (this.doneButton) return false;
    if (this.choices === undefined) return false;
    return this.choices.length >= 0;
  }

  continueStory() {
    const story = this.character.story;
    while (story.canContinue()) {
      let { text, leave } = story.continue();
      if (leave) {
        this.leaveStory();
        return;
      }
      const line = document.createElement("p");
      line.innerHTML = text;
      this.container.appendChild(line);
    }

    if (story.hasCurrentChoices()) {
      this.choices = [];
      this.choiceIndex = -1;
      for (const choice of story.currentChoices()) {
        const choiceLine = document.createElement('p');
        choiceLine.classList.add("choice");

        const choiceButton = document.createElement("button");
        choiceButton.innerText = choice.text;

        choiceButton.addEventListener("click", ev => {
          const existingChoices = this.container.querySelectorAll("p.choice");
          for (let i=0; i < existingChoices.length; i++) {
            let c = existingChoices[i];
            c.parentNode.removeChild(c);
          }
          story.ChooseChoiceIndex(choice.index);
          this.continueStory();
        });

        choiceLine.appendChild(choiceButton);
        this.container.appendChild(choiceLine);
        this.choices.push(choiceButton);
      }

    } else {
      this.doneButton = document.createElement("button");
      this.doneButton.setAttribute("class", "button-done");
      this.doneButton.innerText = "Done";
      
      this.doneButton.addEventListener("click", () => {
        this.leaveStory();
      });

      this.container.appendChild(this.doneButton);
    }
  }

  render(stage) {
  }
}

export default StoryDialog;
